import { render, staticRenderFns } from "./NewPermissionList.vue?vue&type=template&id=9f4e0732&scoped=true"
import script from "./NewPermissionList.vue?vue&type=script&lang=js"
export * from "./NewPermissionList.vue?vue&type=script&lang=js"
import style0 from "./NewPermissionList.vue?vue&type=style&index=0&id=9f4e0732&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4e0732",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f4e0732')) {
      api.createRecord('9f4e0732', component.options)
    } else {
      api.reload('9f4e0732', component.options)
    }
    module.hot.accept("./NewPermissionList.vue?vue&type=template&id=9f4e0732&scoped=true", function () {
      api.rerender('9f4e0732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/NewPermissionList.vue"
export default component.exports